import queryString from 'query-string'

export default class FetchWrapper {

  static async fetch(url, params) {
    try {
      const jwt = queryString.parse(window.location.search).jwt
      url = jwt ? url + '&jwt=' + jwt : url
      let response = await fetch(url, params)
      const regCode = queryString.parse(window.location.search).regCode
      let result = await response.json()
      const { message, status } = result.response
      const statusCode = response.status
      if(response.status === 401) {
        window.location.href = window.location.origin + `/register/1${regCode ? `?regCode=${regCode}` : ``}`
      }
      if (status && status !== 'success' && status !== 200) { 
        if(result.response.errCodeNum || result.response.errorCodeNum){
          return result.response
        }
        else {
          throw { message, statusCode }
        }
      }
      else {
        return result.response
      }
    }  
    catch(error){
      throw error
    }
  }
}
